import { render, staticRenderFns } from "./StudentById.vue?vue&type=template&id=7cf74236&scoped=true&"
import script from "./StudentById.vue?vue&type=script&lang=js&"
export * from "./StudentById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf74236",
  null
  
)

export default component.exports